import React from 'react';
import { Plus } from 'lucide-react';

/**
 * The one way to add something (Oct 2026): a full-width dashed button at the
 * BOTTOM of the list it adds to -- staff, teams, skills, shift types, clinics,
 * positions. It opens that thing's add form (a modal, a drawer, or an inline
 * row in its place). Lists used to mix a primary "Add" button in the control
 * card with this, depending on the tab.
 */
export default function AddNewButton({ label, onClick, className = '', disabled = false }) {
  return (
    <button type="button" onClick={onClick} disabled={disabled}
      className={`w-full h-12 flex items-center justify-center gap-2 rounded-2xl border-2 border-dashed border-slate-200 text-slate-400 hover:border-[var(--primary)] hover:text-[var(--primary)] transition-colors text-xs font-bold disabled:opacity-50 disabled:hover:border-slate-200 disabled:hover:text-slate-400 ${className}`}
      style={{ boxShadow: 'none' }}>
      <Plus className="w-4 h-4" /> {label}
    </button>
  );
}
